module.exports = __webpack_public_path__ + "img/favicon.0d9f7ab2.png";